<template>
  <div id="container">
    <!-- 面包屑 -->
    <div id="Breadcrumb" style="margin-top:20px;display:inline-block">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item >{{title}}</el-breadcrumb-item>
        <el-breadcrumb-item
          v-for="(item, index) in $store.getters.c_bread"
          :key="index"
          :to="{path: item.path}"
        >{{item.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 图像 -->
    <div id="avatar" style="margin-top:10px;display:inline-block; float:right">
      <el-dropdown @command="handleCommand">
        <img
          :style="{width:'40px', height: '40px', cursor: 'pointer', borderRadius: '50%' }"
          :src="avatar"
        />
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="index">昵称:{{$store.getters.c_name}}</el-dropdown-item>
          <!-- <el-dropdown-item divided command="chooseProject">工程选择</el-dropdown-item> -->
          <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
import G from "@/views/common/global";
import lk from "@/api/lk";
import Store from "@/store/index";
export default {
  data() {
    return {
      crumbList: [],
      title: JSON.parse(sessionStorage.getItem("project")).c_name,
      Main: G.Main,
      avatar: require("@/assets/avatar.png"),
      breadCrumbList: []
    };
  },
  created() {
    if (
      typeof this.$store.getters.c_avatar != "undefined" &&
      this.$store.getters.c_avatar != null &&
      this.$store.getters.c_avatar != ""
    ) {
      this.avatar = `data:image/png;base64,${this.$store.getters.c_avatar}`;
    }
  },
  mounted() {},
  methods: {
    handleCommand(command) {
      switch (command) {
        case "chooseProject": {
          this.$router.push("/chooseProject");
          break;
        }
        case "logout":
          {
            lk.logout({
              username: sessionStorage.getItem("username"),
              token: sessionStorage.getItem("token")
            }).then(res => {
              if (res.code == 200) {
                sessionStorage.removeItem("token");
                localStorage.removeItem("token");
                this.$router.push("/login");
                location.reload();
              } else {
                this.$message.error("退出失败");
              }
            });
          }
          break;
      }
    }
  }
};
</script>
<style lang="less">
/deep/ .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  color: #fff;
}
/deep/ .el-breadcrumb__item .el-breadcrumb__inner {
  color: #fff;
}
// 20200609 tz add start
#Breadcrumb {
  background: #fff;
  border-radius: 3px;
  padding: 3px;
}
// 20200609 tz add end
</style>


// WEBPACK FOOTER //
// src/views/common/Breadcrumb.vue